import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	dataDisplay: {
		gridColumn: 'span 4',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 10,
		background: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		boxShadow: '0 0 3px 1px rgba(0,0,0,0.1)',
		padding: THEME.spacing.md,
		minHeight: 120,
		containerType: 'inline-size',
		'@container (max-width: 800px)': {
			gridColumn: 'span 6 !important',
		},
		'@container (max-width: 600px)': {
			gridColumn: 'span 12 !important',
		},
	},
	title: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		textAlign: 'center',
		'@container (max-width: 400px)': {
			fontSize: THEME.typography.fontSizes.md,
		},
		'@container (max-width: 300px)': {
			fontSize: THEME.typography.fontSizes.sm,
		},
	},
	data: {
		fontSize: THEME.typography.fontSizes.xxl,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.dark,
		textAlign: 'center',
		wordBreak: 'break-word',
		'@container (max-width: 400px)': {
			fontSize: THEME.typography.fontSizes.xl,
		},
		'@container (max-width: 300px)': {
			fontSize: THEME.typography.fontSizes.lg,
		},
		'@container (max-width: 250px)': {
			fontSize: THEME.typography.fontSizes.md,
		},
	},
});
